import React from 'react';
import styled from 'styled-components';
import { FaArrowUp, FaArrowDown, FaTrash, FaCopy } from 'react-icons/fa';

const LayerPanelContainer = styled.div`
  background-color:rgb(255, 255, 255);
  color:rgb(107, 107, 107);
  padding: 10px;
  border-radius: 5px;
  width: 250px;
  height: 100%;
  overflow-y: auto;
`;

const LayerTitle = styled.h3`
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #444;
`;

const LayerList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

interface LayerItemProps {
  selected: boolean;
}

const LayerItem = styled.li<LayerItemProps>`
  display: flex;
  align-items: center;
  padding: 8px;
  margin-bottom: 5px;
  background-color: ${props => props.selected ? '#444' : '#333'};
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #444;
  }
`;

const LayerName = styled.span`
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LayerControls = styled.div`
  display: flex;
  gap: 5px;
`;

const ControlButton = styled.button`
  background-color: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 14px;
  padding: 2px;
  &:hover {
    color: #fff;
  }
`;

const AddLayerButton = styled.button`
  width: 100%;
  padding: 8px;
  margin-top: 10px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #357ae8;
  }
`;

interface LayerPanelProps {
  layers: any[];
  selectedLayerId: string | null;
  onSelectLayer: (id: string) => void;
  onMoveLayerUp: (id: string) => void;
  onMoveLayerDown: (id: string) => void;
  onDeleteLayer: (id: string) => void;
  onDuplicateLayer: (id: string) => void;
  onAddTextLayer: () => void;
  onAddImageLayer: () => void;
}


const LayerPanel: React.FC<LayerPanelProps> = ({ 
  layers, 
  selectedLayerId, 
  onSelectLayer, 
  onMoveLayerUp, 
  onMoveLayerDown, 
  onDeleteLayer, 
  onDuplicateLayer,
  onAddTextLayer,
  onAddImageLayer
}) => {
  const [showAddOptions, setShowAddOptions] = React.useState(false);

  return (
    <LayerPanelContainer>
      <LayerTitle>Capas</LayerTitle>
      <LayerList>
        {layers.map((layer) => (
          <LayerItem 
            key={layer.id} 
            selected={layer.id === selectedLayerId}
            onClick={() => onSelectLayer(layer.id)}
          >
            <LayerName>{layer.name}</LayerName>
            <LayerControls>
              <ControlButton onClick={(e) => {
                e.stopPropagation();
                onDuplicateLayer(layer.id);
              }}>
                <FaCopy />
              </ControlButton>
              <ControlButton onClick={(e) => {
                e.stopPropagation();
                onMoveLayerUp(layer.id);
              }}>
                <FaArrowUp />
              </ControlButton>
              <ControlButton onClick={(e) => {
                e.stopPropagation();
                onMoveLayerDown(layer.id);
              }}>
                <FaArrowDown />
              </ControlButton>
              <ControlButton onClick={(e) => {
                e.stopPropagation();
                onDeleteLayer(layer.id);
              }}>
                <FaTrash />
              </ControlButton>
            </LayerControls>
          </LayerItem>
        ))}
      </LayerList>
      
      {showAddOptions ? (
        <>
          <AddLayerButton onClick={() => {
            onAddTextLayer();
            setShowAddOptions(false);
          }}>
            Añadir Texto
          </AddLayerButton>
          <AddLayerButton onClick={() => {
            onAddImageLayer();
            setShowAddOptions(false);
          }}>
            Añadir Imagen
          </AddLayerButton>
          <AddLayerButton onClick={() => setShowAddOptions(false)}>
            Cancelar
          </AddLayerButton>
        </>
      ) : (
        <AddLayerButton onClick={() => setShowAddOptions(true)}>
          Añadir Capa
        </AddLayerButton>
      )}
    </LayerPanelContainer>
  );
};

export default LayerPanel;
